import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { requestSalesReportDataAction } from '../actions';
import { SalesReport } from './index';

const mapStateToProps = (state) => ({
  reportData: state.salesReport.sales.reportData,
  displayState: state.salesReport.sales.displayState,
});

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators({ requestSalesReportDataAction }, dispatch),
});

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(SalesReport);
